
export const addressesFormStateConstants = {
    AddressDisplayForm: 'addressDisplayForm',
    AddressAddForm: 'addressAddForm',
    AddressUpdateForm: 'addressUpdateForm'
};

export const addressesFormCallbackFunctions = {
    HandleShowDisplayAddressForm: 'handleShowDisplayAddressForm',
    HandleShowAddAddressForm: 'handleShowAddAddressForm',
    HandleAddNewAddress: 'handleAddNewAddress',
    HandleShowUpdateAddressForm: 'handleShowUpdateAddressForm',
    HandleUpdateAddress: 'handleUpdateAddress',
    HandleRemoveAddress: 'handleRemoveAddress'
};
